/**
 * Domínio: decide se um evento Meta de etapa do funil deve ir à CAPI (CTWA).
 * Puro — sem infra. Purchase de etapa é ignorado (só no ganho).
 */
import { isCtwaClidWithinPurchaseWindow } from './metaAttributionService';

export const STAGE_META_EVENTS = [
    'Lead',
    'Contact',
    'Schedule',
    'SubmitApplication',
    'CompleteRegistration',
    'AddToCart',
    'InitiateCheckout',
] as const;

export type StageMetaEventName = (typeof STAGE_META_EVENTS)[number];

export type StageMetaSendDecision =
    | { send: true; eventName: StageMetaEventName }
    | { send: false; reason: string };

function normalizeConversionEvent(raw: string | null | undefined): string {
    return (raw || '').trim();
}

export function isStageMetaEventName(value: string): value is StageMetaEventName {
    return (STAGE_META_EVENTS as readonly string[]).includes(value);
}

/**
 * Regras: evento configurado (não Purchase/none), CTWA fresco, ainda não enviado nesta etapa.
 */
export function shouldSendStageMetaEvent(params: {
    conversionEvent: string | null | undefined;
    ctwaClid: string | null | undefined;
    capturedAt: string | null | undefined;
    firstTouchAt?: string | null;
    alreadySentForStage: boolean;
    asOfMs?: number;
}): StageMetaSendDecision {
    const event = normalizeConversionEvent(params.conversionEvent);
    if (!event || event === 'none') {
        return { send: false, reason: 'Etapa sem evento Meta' };
    }
    if (event === 'Purchase') {
        return { send: false, reason: 'Purchase só no ganho da negociação' };
    }
    if (!isStageMetaEventName(event)) {
        return { send: false, reason: `Evento não suportado: ${event}` };
    }
    if (params.alreadySentForStage) {
        return { send: false, reason: 'Evento desta etapa já enviado' };
    }
    const clid = (params.ctwaClid || '').trim();
    if (!clid) {
        return { send: false, reason: 'Sem ctwa_clid' };
    }
    const asOf = params.asOfMs ?? Date.now();
    const clickAt = params.capturedAt || params.firstTouchAt || null;
    if (!isCtwaClidWithinPurchaseWindow(clickAt, asOf)) {
        return { send: false, reason: 'Fora da janela CTWA de 7 dias' };
    }
    return { send: true, eventName: event };
}

export function buildStageMetaEventId(leadId: string, stageId: string, eventName: string): string {
    return `${leadId}:${stageId}:${eventName}`;
}
